import { useAppConstantsContext } from '@/context/AppConstants';
import { Card, Text, Button, Grid, Icons, Divider, Stack } from '@/theme/index';

interface IconContainerProps {
  icon: string;
  description: string;
  id: string;
}

/**
 * This component is responsible for providing users with the ability to see and get started all the title services online.
 */
export const EtagCTA = () => {
  const {
    links: { etagsPartnerUrl = '' },
    images: {
      imgMobileExpIcon,
      imgCopyIcon,
      imgContactlessIcon,
      imgUpdatesIcon,
      imgEtagsLogo,
    },
  } = useAppConstantsContext();

  const iconsList = [
    {
      icon: imgMobileExpIcon,
      description: 'Built for mobile experiences',
      id: 'mobile-exp-icon',
    },
    {
      icon: imgContactlessIcon,
      description: 'Contactless processing',
      id: 'contactless-icon',
    },
    {
      icon: imgCopyIcon,
      description: 'e-Tag Download - FREE',
      id: 'copy-icon',
    },
    {
      icon: imgUpdatesIcon,
      description: 'Email & SMS updates',
      id: 'updates-icon',
    },
  ];

  const checkItemsList = [
    { text: 'Renew your registration', id: 'renew-registration' },
    { text: 'Transfer your title', id: 'transfer-title' },
    { text: 'Replace license plate OR sticker', id: 'replace-license-plate' },
    {
      text: 'Replace a lost title or get an e-title printed',
      id: 'replace-lost-title',
    },
  ];

  const IconContainer = ({ icon, description, id }: IconContainerProps) => {
    return (
      <Grid
        item
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: { xs: '40%', sm: '20%' } }}
      >
        <img src={icon} alt="" data-cy={id} />
        <Text variant="caption">{description}</Text>
      </Grid>
    );
  };

  return (
    <Card variant="outlined" sx={{ textAlign: 'center' }} data-cy="etag-cta">
      <Grid
        container
        flexDirection="column"
        m="auto"
        justifyContent="center"
        sx={{ width: '75%' }}
      >
        <Text variant="h1" marginTop={1} justifyContent="center">
          Skip the long lines at the DMV, do your title services online
        </Text>
        <Grid
          container
          item
          flexDirection="row"
          spacing={2}
          justifyContent="center"
        >
          {iconsList.map((item) => (
            <IconContainer {...item} key={item.id} />
          ))}
        </Grid>
      </Grid>
      <Divider sx={{ mt: 3, mb: 4 }} />
      <Grid container sx={{ width: '75%', m: 'auto' }}>
        {checkItemsList.map((element) => (
          <Grid item display="flex" flexDirection="row" sm={6} key={element.id}>
            <Icons.Check
              color="primary"
              fontSize="small"
              sx={{ marginRight: 1 }}
            />
            <Text variant="body1" textAlign="initial">
              {element.text}
            </Text>
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ mt: 3, mb: 4 }} />
      <Button
        variant="contained"
        color="success"
        onClick={() =>
          window.open(etagsPartnerUrl, '_blank', 'noopener,noreferrer')
        }
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        Get started
      </Button>
      <Stack
        direction="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ mt: 1, ml: 1 }}
      >
        <Text variant="body2" color="text.secondary" fontWeight="bold">
          Powered by
        </Text>
        <img src={imgEtagsLogo} alt="" data-cy="etags-logo" />
      </Stack>
    </Card>
  );
};
